// Centralized disclaimer / footer copy. These strings were duplicated verbatim
// across the calculator pages; a single source keeps them consistent and honest.
// Wording is unchanged from the pages — where variants differed, the canonical
// form is noted below.

// Page-head subtitle used on every calculator (Options, DayTrade, Commodities,
// Forex, Crypto) and Home. Identical everywhere — no variant.
export const RESEARCH_PAPER_DEFAULT =
  'Research and paper by default; owner-only live execution is off unless armed.';

// Footer-banner LEFT cell. Variants differed only in the dash: Options/DayTrade
// used a hyphen ("Paper only - no real capital at risk"); Commodities/Forex/Crypto
// used an em dash. Canonical = the em-dash form (majority + matches the site's
// typography elsewhere).
export const PAPER_ONLY_NO_CAPITAL = 'Paper only — no real capital at risk';

// Footer-banner RIGHT cell on the pricing/sizing pages (Options, Commodities,
// Forex, Crypto). No variant.
export const MODELS_ARE_APPROXIMATIONS = 'Models are approximations, not guarantees.';
